import MenuX from "../MenuX";
import Menu from "../Menu";

function NavSideBar({ user, access, onClickMenu, onSignOut }) {
  return (
    <div
      className="offcanvas-body d-flex flex-column"
      style={{
        backgroundColor: `#ffffff`,
        padding: 0,
        height: "100vh",
        boxShadow: "2px 0 10px rgba(0, 0, 0, 0.08)",
      }}
    >
      {/* Header Section */}
      <div
        style={{
          padding: "0.75rem",
          borderBottom: "1px solid #e9ecef",
          backgroundColor: "#f8f9fa",
        }}
      >
        <div className="d-flex justify-content-end">
          <MenuX />
        </div>

        {/* User Profile Section */}
        <div className="text-center">
          <div className="mb-3">
            <img
              className="img-fluid rounded-circle"
              alt="profile"
              src={user?.profileImage || "/logo.svg"}
              style={{
                width: "80px",
                height: "80px",
                objectFit: "cover",
                border: "2px solid #ffffff",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
              }}
            />
          </div>
          <div className="d-flex flex-column align-items-center">
            <span
              className="text-dark fw-semibold"
              style={{ fontSize: "1.1rem", letterSpacing: "0.3px" }}
            >
              {user.username}
            </span>
            {user.email && (
              <span
                className="text-muted"
                style={{ fontSize: "0.85rem", marginTop: "0.25rem" }}
              >
                {user.email}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Navigation Menu Section */}
      <div
        className="flex-grow-1"
        style={{
          padding: "1.5rem 0.75rem",
          overflowY: "auto",
          flex: "1 1 auto",
        }}
      >
        <Menu onClickItem={onClickMenu} menus={access} />
      </div>

      {/* Footer Section - Logout */}
      <div
        style={{
          padding: "1.25rem",
          borderTop: "1px solid #e9ecef",
          backgroundColor: "#f8f9fa",
        }}
      >
        <button
          className="btn w-100 d-flex align-items-center justify-content-center"
          onClick={onSignOut}
          style={{
            padding: "0.75rem 1rem",
            backgroundColor: "transparent",
            border: "1px solid #dc3545",
            borderRadius: "8px",
            color: "#dc3545",
            fontWeight: "600",
            fontSize: "0.95rem",
            transition: "all 0.2s ease",
            gap: "0.5rem",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#dc3545";
            e.currentTarget.style.color = "#ffffff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "transparent";
            e.currentTarget.style.color = "#dc3545";
          }}
        >
          <i className="bi bi-power" style={{ fontSize: "1.1rem" }}></i>
          <span>Log out</span>
        </button>
      </div>
    </div>
  );
}

export default NavSideBar;
